






import { Component, Vue } from "vue-property-decorator";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import {
  faVuejs,
  faJs,
  faAws,
  faGithub,
  faFigma,
  faSass,
  faDocker,
  faJava,
  faReact,
  faNode
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faExternalLinkAlt);
library.add(
  faVuejs,
  faJs,
  faAws,
  faGithub,
  faFigma,
  faSass,
  faDocker,
  faJava,
  faReact,
  faNode
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

@Component
export default class App extends Vue {}
